export function convertBrTo(target: string, replacer: string): string;
export function convertBrTo<T>(target: T, replacer: string): T;
/**
 * @description
 * 文字列に含まれる改行タグを任意の値に置き換える
 * 前身となる関数を置き換える際に実行時の記述を大きく変えないため、第一引数は unknown としてる
 */
export function convertBrTo(target: unknown, replacer: string) {
  if (typeof target !== "string") return target;
  return target.replace(/<(\/|)br ?(\/|)>/g, replacer);
}

export function convertBrToLineBreakCode(target: string): string;
export function convertBrToLineBreakCode<T>(target: T): T;
/**
 * @description
 * <br> to \n に特化させたカリー化関数
 */
export function convertBrToLineBreakCode(target: unknown) {
  return convertBrTo(target, "\n");
}

export function removeBr(target: string): string;
export function removeBr<T>(target: T): T;
/**
 * @description
 * <br> to "" に特化させたカリー化関数
 */
export function removeBr(target: unknown) {
  return convertBrTo(target, "");
}
